import { ResetPasswordComponent } from 'src/app/shared/auth/reset-password/reset-password.component';
import { featureToggleGuard } from '../services/feature-toggle/feature-toggle.guard';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { RegistrationComponent } from './register/registration/registration.component';
import { Feature } from '../model/features.enum';
import { loginGuard } from '../guard/login.guard';
import { OauthParentComponent } from './oauth-parent/oauth-parent.component';

export const authRoutes = [
  {
    path: '',
    canActivate: [loginGuard],
    canMatch: [featureToggleGuard(Feature.WebBackend)],
    component: OauthParentComponent,
  },
  {
    path: '',
    component: LoginComponent,
  },
  {
    path: 'login',
    canMatch: [featureToggleGuard(Feature.WebBackend)],
    component: OauthParentComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'forgot-password',
    title: 'Forgot Password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'reset-password/:token',
    title: 'Reset Password',
    component: ResetPasswordComponent,
  },
  {
    path: 'register',
    title: 'Register',
    canActivate: [loginGuard],
    canMatch: [featureToggleGuard(Feature.WebBackend)],
    component: RegistrationComponent,
  },
  {
    path: 'register',
    title: 'Register',
    component: RegisterComponent,
  },
];
